export default class ImagePopup {
  constructor() {
    if (
      (this.openImagePopups = document.querySelectorAll('.js-open-image-popup'))
    ) {
      for (let i = 0, l = this.openImagePopups.length; i < l; i++) {
        this.openImagePopups[i].addEventListener(
          'click',
          this._handleOpenClick
        );
      }
    }

    if (
      (this.closeImagePopups = document.querySelectorAll(
        '.js-close-image-popup'
      ))
    ) {
      for (let i = 0, l = this.closeImagePopups.length; i < l; i++) {
        this.closeImagePopups[i].addEventListener(
          'click',
          this._handleCloseClick
        );
      }
    }

    this._clickOutside();
  }

  _handleOpenClick(e) {
    e.stopPropagation();

    const card = e.target;

    const imageModal = document.querySelector('.image-modal');

    if (!imageModal) {
      return;
    }

    const modalTitle = imageModal.querySelector('.modal-title');

    const title = card.dataset.title;

    modalTitle.textContent = title;

    const modalContent = imageModal.querySelector('.modal-content');

    const imageUrl = card.dataset.imageUrl;

    modalContent.innerHTML = `<img src="${imageUrl}" alt="${title}" title="${title}" class="image-popup" />`;

    if (imageModal.classList.contains('visible')) {
      imageModal.classList.remove('visible');
    } else {
      imageModal.classList.add('visible');
    }
  }

  _handleCloseClick(e) {
    e.stopPropagation();

    const imageModal = document.querySelector('.image-modal');

    if (!imageModal) {
      return;
    }

    if (imageModal.classList.contains('visible')) {
      imageModal.classList.remove('visible');
    }
  }

  _clickOutside() {
    const imageModal = document.querySelector('.image-modal');

    if (!imageModal) {
      return;
    }

    imageModal.addEventListener('click', function (e) {
      const isOutside = !e.target.closest('.modal-container');

      if (isOutside) {
        if (imageModal.classList.contains('visible')) {
          imageModal.classList.remove('visible');
        }
      }
    });
  }
}
